import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';


class CancelApp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            trigger: false,
            appointmentCanceled: false,
        };

        this.triggetNext = this.triggetNext.bind(this);
    }

    componentDidMount() {

        // Uncommented this for skiping appointment cancel step
        //---------------------------------
        const {steps,cancelFor} = this.props;
        // let trigger_value = '';
        // switch (this.props.steps.option.value) {
        //     case 'CancelApp':
        //         trigger_value = 'would_you_like_to_do_something_else';
        //         break;
        //     case 'RescheduleApp':
        //         trigger_value = 'reschedulePleaseChoseDayAndTime';
        //         break;
        //     default:
        //         trigger_value = 'say_how_can_help';
        //
        // }
        // this.triggetNext(true, trigger_value);
        // return;
        //------------------------------

        let appointment_id = null;
        if (cancelFor === 'reschedule'){
            appointment_id = steps.ChooseAppForReschedule.value.id;
        }else{
            appointment_id = steps.ChooseAppForCancel.value.id;
        }
        const bodyFormData = new FormData();
        bodyFormData.append('appointment_id', appointment_id);

        if(this.props.steps.option.value === "RescheduleApp"){
            this.triggetNext({appointment_id: appointment_id}, 'reschedulePleaseChoseDayAndTime');
        }else {
            API.cancelApp(bodyFormData)
                .then((res) => {
                    const result = res.data;
                    // debugger;
                    if (result.status == "success") {
                        this.setState(
                            {loading: false, appointmentCanceled: true}
                        );
                        let trigger_value = '';
                        switch (this.props.steps.option.value) {
                            case 'CancelApp':
                                trigger_value = 'cancelAppSuccess_msg';
                                break;
                            case 'RescheduleApp':
                                trigger_value = 'reschedulePleaseChoseDayAndTime';
                                break;
                            default:
                                trigger_value = 'say_how_can_help';

                        }

                        this.triggetNext(true, trigger_value);
                    }

                }).catch((error) => {
                this.setState({
                    error: 'Error retrieving data',
                    loading: false
                });
                this.triggetNext(false, 'say_hello');

            });
        }

    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    render() {
        const {loading, appointmentCanceled} = this.state;
        const {step} = this.props;

        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                   ''
                )}
            </div>
        );
    }

}

CancelApp.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

CancelApp.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default CancelApp;
